import { css } from '@emotion/core';
import { typographyStyles } from '@newsela/angelou';

const { textM } = typographyStyles;

export const $searchInput = [textM, css`
    padding: 12px;
    border: solid 1px #77767A;
    margin-right: 8px;
    border-radius: 8px;
    flex: 1;
  `
];
